// App.js - 主入口文件
import React from 'react';
import StrokeIntakeApp from './components/StrokeIntakeApp';
import './styles/global.css';

function App() {
  return (
      <div className="app-container">
        <StrokeIntakeApp />
      </div>
  );
}

export default App;